import React from 'react';
import Skeleton from 'components/general/Skeleton/Skeleton';
import SkeletonParagraph from 'components/general/Skeleton/SkeletonParagraph';

const ArticleHeaderSkeleton: React.SFC<SkeletonProps> = ({ summary }) => (
  <div className="article-header">
    <div className="article-header__inner">
      <div className="article-header__category">
        <Skeleton width={[50, 70]} unit="%" />
      </div>
      <div className="article-header__title">
        <Skeleton types={['xl']} />
      </div>
      {summary && (
        <div className="article-header__summary">
          <SkeletonParagraph lines={4} />
        </div>
      )}
    </div>
  </div>
);

ArticleHeaderSkeleton.defaultProps = {
  summary: false,
};

interface SkeletonProps {
  summary?: boolean;
}

export default ArticleHeaderSkeleton;

